import React, { useEffect, useState } from 'react';
import { cn } from '../../lib/utils';
import { useMotionValue, motion, useMotionTemplate } from 'framer-motion';
export const HeroHighlight = ({
  children,
  className,
  containerClassName
}: {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}) => {
  let mouseX = useMotionValue(0);
  let mouseY = useMotionValue(0);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  useEffect(() => {
    if (!isMobile) return;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const videoSectionOffset = viewportHeight * 0.25;
      const adjustedScrollY = Math.max(0, scrollY - videoSectionOffset);
      const adjustedDocumentHeight = documentHeight - videoSectionOffset;
      const scrollPercentY = Math.min(adjustedScrollY / (adjustedDocumentHeight - viewportHeight), 1);
      mouseX.set(window.innerWidth / 2);
      mouseY.set(videoSectionOffset + scrollPercentY * (documentHeight - viewportHeight));
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile, mouseX, mouseY]);
  function handleMouseMove({
    currentTarget,
    clientX,
    clientY
  }: React.MouseEvent<HTMLDivElement>) {
    if (isMobile) return;
    if (!currentTarget) return;
    let {
      left,
      top
    } = currentTarget.getBoundingClientRect();
    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }
  return <div className={cn('relative min-h-screen flex items-start bg-white justify-center w-full group', containerClassName)} onMouseMove={handleMouseMove} data-id="element-251">
      <div className={cn('relative z-20 w-full', className)} data-id="element-252">{children}</div>
    </div>;
};
export const Highlight = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <motion.span initial={{
    backgroundSize: '0% 100%',
    opacity: 0
  }} whileInView={{
    backgroundSize: '100% 100%',
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut',
    delay: 0.1
  }} style={{
    backgroundImage: 'linear-gradient(to right, #2c3a80, #1e2a66)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    display: 'inline'
  }} className={cn('relative inline-block pb-1 px-1 rounded-lg text-white', className)} data-id="element-253">
      {children}
    </motion.span>;
};